import * as React from "react";
import * as Glob from "../../Globale";
import * as Dati from "../../Dati";
import * as Data from "../../Data";
import * as Compat from "../../Compat";
import { ChiamaAPI, Trad, BaseComponent, BottoneAPI } from "../";
import { NavLink } from "react-router-dom";
import { Layout } from "../../layout/Layout";
import * as H from "history";
import { PortletToogleIcon } from "../common/PortletToogleIcon";
import * as Dashboard from "./Dashboard";
import { GetURL } from "../../inar2/helpers/Policies";

interface IDashboardUltimiAggiornamentiProps {
    History: H.History;
}

interface IDashboardUltimiAggiornamentiState {
    Aggiorna: number;
}

export class DashboardUltimiAggiornamenti extends BaseComponent<IDashboardUltimiAggiornamentiProps, IDashboardUltimiAggiornamentiState> {
    public constructor(props: any) {
        super(props);
        this.state = { Aggiorna: 1 };
    }

    private OnRisUltimePolizze(sender: ChiamaAPI, dati: Dati.CRisAPILista<Dati.CDashboardUltimiAggiornamentiPolizza>, datiNuovi: boolean): React.ReactNode {
        let html: any[] = [];
        for (let i: number = 0; i < dati.Dati.length; i++) {
            let Stato: any = <span></span>;
            if (dati.Dati[i].ID_TipoPolizzaStato == Glob.Tipi_PS_Approvata) {
                Stato = <span className="arancione">{Trad.Trad(dati.Dati[i].StatoPolizza)}</span>;
            } else if (dati.Dati[i].ID_TipoPolizzaStato == Glob.Tipi_PS_Emessa) {
                Stato = <span className="verde">{Trad.Trad(dati.Dati[i].StatoPolizza)}</span>;
            } else if (dati.Dati[i].ID_TipoPolizzaStato == Glob.Tipi_PS_Emessa_Firmata) {
                Stato = <span className="verdelight">{Trad.Trad(dati.Dati[i].StatoPolizza)}</span>;
            } else if (dati.Dati[i].ID_TipoPolizzaStato == Glob.Tipi_PS_Rifiuto || dati.Dati[i].ID_TipoPolizzaStato == Glob.Tipi_PS_Annullata) {
                Stato = <span className="rosso">{Trad.Trad(dati.Dati[i].StatoPolizza)}</span>;
            } else {
                Stato = <span>{Trad.Trad(dati.Dati[i].StatoPolizza)}</span>;
            }
            html.push(
                this.GetRecord(
                    "Polizza_" + i,
                    dati.Dati[i].Immagine,
                    dati.Dati[i].Nome,
                    dati.Dati[i].Cognome,
                    dati.Dati[i].Nome + " " + dati.Dati[i].Cognome,
                    Trad.Trad(dati.Dati[i].TipoRamo) + " - " + dati.Dati[i].Contraente,
                    dati.Dati[i].Company,
                    dati.Dati[i].Polizza,
                    Stato,
                    GetURL(dati.Dati[i])
                )
            );
        }
        return html;
    }

    private OnRisUltimiPreventivi(sender: ChiamaAPI, dati: Dati.CRisAPILista<Dati.CDashboardUltimiAggiornamentiPolizza>, datiNuovi: boolean): React.ReactNode {
        let html: any[] = [];
        for (let i: number = 0; i < dati.Dati.length; i++) {
            let Stato: any = <span></span>;
            if (dati.Dati[i].ID_TipoPolizzaStato == Glob.Tipi_PS_Approvata) {
                Stato = <span className="arancione">{Trad.Trad(dati.Dati[i].StatoPolizza)}</span>;
            } else if (dati.Dati[i].ID_TipoPolizzaStato == Glob.Tipi_PS_Emessa) {
                Stato = <span className="verde">{Trad.Trad(dati.Dati[i].StatoPolizza)}</span>;
            } else if (dati.Dati[i].ID_TipoPolizzaStato == Glob.Tipi_PS_Rifiuto || dati.Dati[i].ID_TipoPolizzaStato == Glob.Tipi_PS_Annullata) {
                Stato = <span className="rosso">{Trad.Trad(dati.Dati[i].StatoPolizza)}</span>;
            } else {
                Stato = <span>{Trad.Trad(dati.Dati[i].StatoPolizza)}</span>;
            }
            html.push(
                this.GetRecord(
                    "Preventivo_" + i,
                    dati.Dati[i].Immagine,
                    dati.Dati[i].Nome,
                    dati.Dati[i].Cognome,
                    dati.Dati[i].Nome + " " + dati.Dati[i].Cognome,
                    Trad.Trad(dati.Dati[i].TipoRamo) + " - " + dati.Dati[i].Contraente,
                    dati.Dati[i].Company,
                    dati.Dati[i].Polizza,
                    Stato,
                    GetURL(dati.Dati[i])
                )
            );
        }
        return html;
    }

    private OnRisUltimiPreventiviInviati(sender: ChiamaAPI, dati: Dati.CRisAPILista<Dati.CDashboardUltimiAggiornamentiPolizza>, datiNuovi: boolean): React.ReactNode {
        let html: any[] = [];
        for (let i: number = 0; i < dati.Dati.length; i++) {
            let Stato: any = <span></span>;
            if (dati.Dati[i].ID_TipoPolizzaStato == Glob.Tipi_PS_Approvata) {
                Stato = <span className="arancione">{Trad.Trad(dati.Dati[i].StatoPolizza)}</span>;
            } else if (dati.Dati[i].ID_TipoPolizzaStato == Glob.Tipi_PS_Emessa) {
                Stato = <span className="verde">{Trad.Trad(dati.Dati[i].StatoPolizza)}</span>;
            } else if (dati.Dati[i].ID_TipoPolizzaStato == Glob.Tipi_PS_Rifiuto || dati.Dati[i].ID_TipoPolizzaStato == Glob.Tipi_PS_Annullata) {
                Stato = <span className="rosso">{Trad.Trad(dati.Dati[i].StatoPolizza)}</span>;
            } else {
                Stato = <span>{Trad.Trad(dati.Dati[i].StatoPolizza)}</span>;
            }
            html.push(
                this.GetRecord(
                    "Preventivo_" + i,
                    dati.Dati[i].Immagine,
                    dati.Dati[i].Nome,
                    dati.Dati[i].Cognome,
                    dati.Dati[i].Nome + " " + dati.Dati[i].Cognome,
                    Trad.Trad(dati.Dati[i].TipoRamo) + " - " + dati.Dati[i].Contraente,
                    "",
                    dati.Dati[i].Polizza,
                    Stato,
                    GetURL(dati.Dati[i])
                )
            );
        }
        return html;
    }

    private OnRisUltimiRinnovi(sender: ChiamaAPI, dati: Dati.CRisAPILista<Dati.CDashboardUltimiAggiornamentiPolizza>, datiNuovi: boolean): React.ReactNode {
        let html: any[] = [];
        for (let i: number = 0; i < dati.Dati.length; i++) {
            let Stato: any = <span></span>;
            if (dati.Dati[i].ID_TipoPolizzaStato == Glob.Tipi_PS_InRinnovoConsolidata) {
                Stato = <span className="arancione">{Trad.Trad(dati.Dati[i].StatoPolizza)}</span>;
            } else if (dati.Dati[i].ID_TipoPolizzaStato == Glob.Tipi_PS_InRinnovo) {
                Stato = <span className="verde">{Trad.Trad(dati.Dati[i].StatoPolizza)}</span>;
            } else {
                Stato = <span>{Trad.Trad(dati.Dati[i].StatoPolizza)}</span>;
            }
            html.push(
                this.GetRecord(
                    "Preventivo_" + i,
                    dati.Dati[i].Immagine,
                    dati.Dati[i].Nome,
                    dati.Dati[i].Cognome,
                    dati.Dati[i].Nome + " " + dati.Dati[i].Cognome,
                    Trad.Trad(dati.Dati[i].TipoRamo) + " - " + dati.Dati[i].Contraente,
                    "",
                    dati.Dati[i].Polizza,
                    Stato,
                    GetURL(dati.Dati[i])
                )
            );
        }
        return html;
    }
    
    private OnRisUltimiAffidamenti(sender: ChiamaAPI, dati: Dati.CRisAPILista<Dati.CDashboardUltimiAggiornamentiFideAffidamento>, datiNuovi: boolean): React.ReactNode {
        let html: any[] = [];
        for (let i: number = 0; i < dati.Dati.length; i++) {
            let Stato: any = <span></span>;
            if (dati.Dati[i].ID_TipoFideAffidamentoEsito == Glob.Tipi_FAE_Sottoscritto) {
                Stato = <span className="verde">{Trad.Trad(dati.Dati[i].ID_TipoFideAffidamentoEsito)}</span>;
            } else if (dati.Dati[i].ID_TipoFideAffidamentoEsito == Glob.Tipi_FAE_Rifiuto) {
                Stato = <span className="rosso">{Trad.Trad(dati.Dati[i].ID_TipoFideAffidamentoEsito)}</span>;
            } else {
                Stato = <span>{Trad.Trad(dati.Dati[i].ID_TipoFideAffidamentoEsito)}</span>;
            }

            html.push(
                this.GetRecord(
                    "Affidamento_" + i,
                    dati.Dati[i].Immagine,
                    dati.Dati[i].Nome,
                    dati.Dati[i].Cognome,
                    dati.Dati[i].Nome + " " + dati.Dati[i].Cognome,
                    dati.Dati[i].DenominazioneDa + " => " + dati.Dati[i].DenominazioneA,
                    "",
                    dati.Dati[i].ID_FideAffidamento.toString(),
                    Stato,
                    "/anagrafica/" + dati.Dati[i].ID_AnagA.toString() + "/fideaffidamento/" + dati.Dati[i].ID_FideAffidamento.toString() + "/" + Data.DataValoreCompleta(dati.Dati[i].RigaInizio)
                )
            );
        }
        return html;
    }

    private OnRisUltimeDeroghe(sender: ChiamaAPI, dati: Dati.CRisAPILista<Dati.CDashboardUltimiAggiornamentiDeroga>, datiNuovi: boolean): React.ReactNode {
        let html: any[] = [];
        for (let i: number = 0; i < dati.Dati.length; i++) {
            let Stato: any = <span></span>;
            let URL: any = "";
            let ID: string = "";
            if (dati.Dati[i].ID_TipoDerogaStato == Glob.Tipi_DR_Approvata) {
                Stato = <span className="verde">{Trad.Trad(dati.Dati[i].ID_TipoDerogaStato)}</span>;
                URL = (
                    <BottoneAPI
                        Default={false}
                        URL={"/api/Url/GetURL?template=" + Layout.GetTemplateUrl(dati.Dati[i].ID_TipoDerogaTipo) + "&tipo=" + dati.Dati[i].ID_TipoDerogaTipo + "&chiave=" + dati.Dati[i].ID_Deroga}
                        Metodo="GET"
                        OnClick={(s, d) => Layout.OnClickUrl(s, d, this.props.History)}
                        OnErrore={(s, e) => this.OnErrore(s, e)}
                        Visibile={true}
                        ClasseAttivo="btn btn-brand m-btn m-btn--icon btn-sm square-button-with-icon"
                        ClasseAttesa="btn btn-brand m-btn m-btn--icon btn-smsquare-button-with-icon"
                        Icona="la la-edit"
                    />
                );
            } else if (dati.Dati[i].ID_TipoDerogaStato == Glob.Tipi_DR_Rifiutata) {
                Stato = <span className="rosso">{Trad.Trad(dati.Dati[i].ID_TipoDerogaStato)}</span>;
                URL = (
                    <button
                        className="btn btn-brand m-btn m-btn--icon btn-sm square-button-with-icon"
                        onClick={e => {
                            e.preventDefault();
                            Glob.InfoModaleError(Trad.Trad("MOTIVAZIONE"), dati.Dati[i].Note);
                        }}
                    >
                        <i className="la la-edit"></i>
                    </button>
                );
            } else {
                Stato = <span>{Trad.Trad(dati.Dati[i].ID_TipoDerogaStato)}</span>;
                URL = "/Deroga";
            }

            if (dati.Dati[i].Polizza == "") {
                ID = dati.Dati[i].ID_Deroga.toString();
            } else {
                ID = dati.Dati[i].Polizza;
            }

            html.push(
                this.GetRecord(
                    "Deroga_" + i,
                    dati.Dati[i].Immagine,
                    dati.Dati[i].Nome,
                    dati.Dati[i].Cognome,
                    dati.Dati[i].Nome + " " + dati.Dati[i].Cognome,
                    Trad.Trad(dati.Dati[i].ID_TipoDerogaTipo),
                    "",
                    ID,
                    Stato,
                    URL
                )
            );
        }
        return html;
    }

    private GetRecord(
        key: string,
        immagine: string,
        nome: string,
        cognome: string,
        titolo: string,
        sottoTitolo: string,
        company: string | any,
        infoUno: string | any,
        infoDue: string | any,
        link: string | any
    ): React.ReactNode {
        let Link: any = "";
        if (typeof link == "string") {
            Link = (
                <NavLink to={link} className="btn btn-brand m-btn m-btn--icon btn-sm square-button-with-icon">
                    <i className="la la-edit"></i>
                </NavLink>
            );
        } else {
            Link = link;
        }
        return (
            <div className="kt-widget4__item widget" key={key}>
                <div className="kt-widget4__pic kt-widget4__pic--xl kt-widget4__pic--circle widget-pick">
                    <img src={Compat.ES6_String_startWith(immagine, "http") ? immagine : "/cdn/users/" + immagine} alt={nome + " " + cognome} />
                </div>
                <div className="kt-widget4__info widget-info">
                    <span className="kt-widget4__title">{titolo}</span>
                    <br/>
                    <span className="kt-widget4__sub">{sottoTitolo}</span>
                    <br/>
                    <span className="kt-widget17__progress-label header6">{company}</span>
                </div>
                <div className="kt-widget4__progress widget-progress">
                <div className="kt-widget4__progress-wrapper">
                        <span className="kt-widget17__progress-number">{infoUno}</span>
                        <span className="kt-widget17__progress-label">{infoDue}</span>
                    </div>
                </div>
                <div className="kt-widget4__ext">{Link}</div>
            </div>
        );
    }

    componentDidMount() {
        setInterval(() => {
            this.setState({ Aggiorna: this.state.Aggiorna + 1 });
        }, Dashboard.SecondsAutomaticUpdate * 1000);
    }

    public render() {
        let FideAffidamentoMenu: any = "";
        let FideAffidamentoCorpo: any = "";
        if (Glob.GetSessione().Autorizzazioni["FideAffidamentoController"] >= 1) {
            FideAffidamentoMenu = (
                <li className="nav-item kt-tabs__item">
                    <a className="nav-link tabs__link" data-toggle="tab" href="#kt_DashboardUltimiAggiornamenti_tab2_content" role="tab">
                        {Trad.Trad("Affidamenti")}
                    </a>
                </li>
            );

            FideAffidamentoCorpo = (
                <div className="tab-pane" id="kt_DashboardUltimiAggiornamenti_tab2_content">
                    <div className="kt-widget4 kt-widget4--progress">
                        <ChiamaAPI
                            Aggiornare={this.state.Aggiorna}
                            URL={"/api/FideAffidamento/UltimiAggiornamenti"}
                            OnRis={(s, d, dn) => this.OnRisUltimiAffidamenti(s, d, dn)}
                            OnErrore={this.OnErrore}
                            ImmaginePrecaricamento={true}
                        />
                    </div>
                </div>
            );
        }

        let PolizzaMenu: any = "";
        let PolizzaCorpo: any = "";

        PolizzaMenu = (
            <li className="nav-item kt-tabs__item">
                <a className="nav-link tabs__link" data-toggle="tab" href="#m_DashboardUltimiAggiornamenti_tab1_content" role="tab">
                    {Trad.Trad("Polizze")}
                </a>
            </li>
        );

        PolizzaCorpo = (
            <div className="tab-pane" id="m_DashboardUltimiAggiornamenti_tab1_content">
                <div className="kt-widget4 kt-widget4--progress">
                    <ChiamaAPI
                        Aggiornare={this.state.Aggiorna}
                        URL={"/api/Polizza/UltimiAggiornamenti?polizza=true"}
                        OnRis={(s, d, dn) => this.OnRisUltimePolizze(s, d, dn)}
                        OnErrore={this.OnErrore}
                        ImmaginePrecaricamento={true}
                    />
                </div>
            </div>
        );

        let PreventivoMenu: any = "";
        let PreventivoCorpo: any = "";
        PreventivoMenu = (
            <li className="nav-item kt-tabs__item">
                <a className="nav-link tabs__link active" data-toggle="tab" href="#m_DashboardUltimiAggiornamenti_tab2_content" role="tab">
                    {Trad.Trad("Preventivi")}
                </a>
            </li>
        );

        PreventivoCorpo = (
            <div className="tab-pane active" id="m_DashboardUltimiAggiornamenti_tab2_content">
                <div className="kt-widget4 kt-widget4--progress">
                    <ChiamaAPI
                        Aggiornare={this.state.Aggiorna}
                        URL={"/api/Polizza/UltimiAggiornamenti?polizza=false"}
                        OnRis={(s, d, dn) => this.OnRisUltimiPreventivi(s, d, dn)}
                        OnErrore={this.OnErrore}
                        ImmaginePrecaricamento={true}
                    />
                </div>
            </div>
        );
        
        let PreventivoInviatoMenu: any = "";
        let PreventivoInviatoCorpo: any = "";
        if (Glob.GetSessione().Autorizzazioni["FideAffidamentoController"] >= 10) {
            PreventivoInviatoMenu = (
                <li className="nav-item kt-tabs__item">
                    <a className="nav-link tabs__link" data-toggle="tab"
                       href="#m_DashboardUltimiAggiornamenti_tab3_content" role="tab">
                        {Trad.Trad("Preventivi bozza inviata")}
                    </a>
                </li>
            );

            PreventivoInviatoCorpo = (
                <div className="tab-pane" id="m_DashboardUltimiAggiornamenti_tab3_content">
                    <div className="kt-widget4 kt-widget4--progress">
                        <ChiamaAPI
                            Aggiornare={this.state.Aggiorna}
                            URL={"/api/Polizza/UltimiAggiornamenti?polizza=false&draft=true"}
                            OnRis={(s, d, dn) => this.OnRisUltimiPreventiviInviati(s, d, dn)}
                            OnErrore={this.OnErrore}
                            ImmaginePrecaricamento={true}
                        />
                    </div>
                </div>
            );
        }

        let RinnovoMenu: any = "";
        let RinnovoCorpo: any = "";
        if (Glob.GetSessione().Autorizzazioni["RenewalsController"] >= 1) {
            RinnovoMenu = (
                <li className="nav-item kt-tabs__item">
                    <a className="nav-link tabs__link" data-toggle="tab"
                       href="#m_DashboardUltimiAggiornamenti_tab6_content" role="tab">
                        {Trad.Trad("Rinnovi")}
                    </a>
                </li>
            );

            RinnovoCorpo = (
                <div className="tab-pane" id="m_DashboardUltimiAggiornamenti_tab6_content">
                    <div className="kt-widget4 kt-widget4--progress">
                        <ChiamaAPI
                            Aggiornare={this.state.Aggiorna}
                            URL={"/api/Renewals/LastUpdates"}
                            OnRis={(s, d, dn) => this.OnRisUltimiRinnovi(s, d, dn)}
                            OnErrore={this.OnErrore}
                            ImmaginePrecaricamento={true}
                        />
                    </div>
                </div>
            );
        }
        
        let DerogaMenu: any = "";
        let DerogaCorpo: any = "";
        if (Glob.GetSessione().Autorizzazioni["DerogaController"] >= 10) {
            DerogaMenu = (
                <li className="nav-item kt-tabs__item">
                    <a className="nav-link tabs__link" data-toggle="tab" href="#m_DashboardUltimiAggiornamenti_tab4_content" role="tab">
                        {Trad.Trad("Deroghe")}
                    </a>
                </li>
            );

            DerogaCorpo = (
                <div className="tab-pane" id="m_DashboardUltimiAggiornamenti_tab4_content">
                    <div className="kt-widget4 kt-widget4--progress">
                        <ChiamaAPI
                            Aggiornare={this.state.Aggiorna}
                            URL={"/api/Deroga/UltimiAggiornamenti"}
                            OnRis={(s, d, dn) => this.OnRisUltimeDeroghe(s, d, dn)}
                            OnErrore={this.OnErrore}
                            ImmaginePrecaricamento={true}
                        />
                    </div>
                </div>
            );
        }

        return (
            <div className="kt-portlet portlet-shadow portlet-center kt-portlet--sortable" data-ktportlet="true">
                <div className="kt-portlet__head ui-sortable-handle">
                    <div className="kt-portlet__head-label">
                        <h3 className="kt-portlet__head-label">{Trad.Trad("UltimiAggiornamenti")}</h3>
                    </div>
                    <div className="kt-portlet__head-toolbar">
                        <ul className="nav nav-pills nav-pills--brand kt-nav-pills--align-right kt-nav-pills--btn-pill kt-nav-pills--btn-sm" role="tablist">
                            {PolizzaMenu}
                            {PreventivoMenu}
                            {/*{PreventivoInviatoMenu}*/}
                            {RinnovoMenu}
                            {FideAffidamentoMenu}
                            {/*{DerogaMenu}*/}
                        </ul>
                        <PortletToogleIcon />
                    </div>
                </div>
                <div className="kt-portlet__body">
                    <div className="tab-content">
                        {PolizzaCorpo}
                        {PreventivoCorpo}
                        {/*{PreventivoInviatoCorpo}*/}
                        {RinnovoCorpo}
                        {FideAffidamentoCorpo}
                        {/*{DerogaCorpo}*/}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Dashboards/DashboardUltimiAggiornamenti.tsx